import React , {useState, useEffect}from "react";
import EstacionamientoSmallHeader from "./EstacionamientoSmallHeader";
import "bootstrap/dist/css/bootstrap.min.css";
import EstacionamientoService from "../../services/EstacionamientoService";

import { useNavigate, NavLink, Navigate } from "react-router-dom";
import MapasLugaresLibres from "./MapaLugaresLibres";
import MapaLibres from "../Mapas/MapaLibres";


const EstacionamientoMapas = () => {
    const navigate = useNavigate();
    const [loaded, setLoaded] = useState(false);
    const [listaLibres, setListaLibres] = useState({});


    useEffect(()=> {
       /* if (!loaded) {
        EstacionamientoService.buscarLugaresLibres( "-34.4597619","-58.9132961")
            .then((resp) => { setListaLibres(resp.data);
            setLoaded(true);
        })
            .catch((error) => { setListaLibres(null);});}*/
      }, []);
    return (
        <>
       <div class="container text-center mainContent" >
       <EstacionamientoSmallHeader texto="Lugares disponibles en este momento" retorno="/estacionamiento"/>
      
       
                  <MapaLibres />
                </div>
          
        
        
        </>

    );
    }
export default EstacionamientoMapas;